<template>
  <van-popup v-model:show="isShowLogin" class="login-component" teleport="body">
    <img class="login-logo" src="@/assets/image/login/logo.png" alt="" />
    <!-- 谷歌登录,在 Feacbook APP && IOS 就不显示谷歌登录 -->
    <van-button
      v-show="!(browser.facebook && browser.ios)"
      class="btn-google"
      :disabled="loginBtnLogging.isApple || loginBtnLogging.isGoogle"
      @click="handleGoogleLogin"
    >
      <div class="flex center">
        <img
          class="google-icon"
          src="@/assets/image/login/google_icon.png"
          alt=""
        />
        <van-loading v-if="loginBtnLogging.isGoogle" color="#333333" size="12px"
          >logging in...</van-loading
        >
        <span v-else>Continue with Google</span>
      </div>
    </van-button>
    <!-- Apple登录 -->
    <van-button
      class="btn-apple flex center"
      :disabled="loginBtnLogging.isApple || loginBtnLogging.isGoogle"
      @click="handleAppleLogin"
    >
      <img
        class="apple-icon"
        src="@/assets/image/login/apple_icon.png"
        alt=""
      />
      <van-loading v-if="loginBtnLogging.isApple" color="#333333" size="12px"
        >logging in...</van-loading
      >
      <span v-else>Continue with Apple</span>
    </van-button>

    <!-- 测试使用 输入ID start -->
    <template v-if="isShowTestLogin">
      <div class="test-id flex center">
        <img
          class="phone-icon"
          src="@/assets/image/login/phone_icon.png"
          alt=""
        />
        <input
          v-model.number="unionid"
          type="number"
          placeholder="请输入测试ID"
        />
      </div>
      <van-button class="test-btn flex center" @click="handleLoginTest">
        测试登录按钮
      </van-button>
    </template>

    <!-- 测试使用 输入ID end -->
    <div class="msg">{{ $t('login.msg') }}</div>
    <div class="app-store flex center">
      <!-- <van-button
        v-if="browser.ios"
        class="app-store-btn apple-btn"
        @click="handleToApp(1)"
      ></van-button> -->
      <van-button
        v-if="!browser.ios"
        class="app-store-btn google-btn"
        @click="handleToApp(2)"
      ></van-button>
    </div>
  </van-popup>
</template>

<!-- 登录弹窗 
  示例：
  import Login from '@/components/Login/index.vue'
  
  <Login />
-->
<script setup lang="ts">
defineOptions({ name: 'Login' })

const browser = ref()
if (process.client) {
  browser.value = common.checkVersion()
}

const runtimeConfig = useRuntimeConfig()

const loginStore = useLoginStore()
const { loginBtnLogging, isShowLogin } = storeToRefs(loginStore)

// 监听路由，切换页面关闭弹窗
const router = useRouter()
router.afterEach(() => {
  loginStore.setIsShowLogin(false) // 关闭登录窗口
})

// 跳转应用市场
function handleToApp(type) {
  // if (type == 1) {
  //   // 苹果
  //   eventTracking.eventLog(eventTracking.eventId.go_to_appstore)
  // } else {
  //   // 谷歌
  //   eventTracking.eventLog(eventTracking.eventId.go_to_google_play)
  // }
  // 延迟500是为了能触发埋点
  setTimeout(() => {
    // location.href = runtimeConfig.public.downloadUrl
    location.href = runtimeConfig.public.downloadGoogle
  }, 500)
}

// // 是否是生产环境和预发布环境
// const isShowProdLogin = ref(
//   runtimeConfig.public.appMode == 'production' ||
//     runtimeConfig.public.appMode == 'release'
// )

// 是否是测试环境和本地环境
const isShowTestLogin = ref(
  runtimeConfig.public.appMode == 'development' ||
    runtimeConfig.public.appMode == 'test'
)

// 测试登录
const unionid = ref<number>()
// 缓存测试ID，方便下次登录
if (process.client && localStorage.getItem('testId')) {
  unionid.value = Number(localStorage.getItem('testId')) || 0
}
async function handleLoginTest() {
  if (!unionid.value) {
    showToast('请输入测试账号')
    return
  }
  localStorage.setItem('testId', unionid.value.toString())
  loginStore.testLogin(unionid.value)
}

// 动态添加appleIdCDN
let isLoadappleIdCDN = false
onMounted(() => {
  common.loadScript(
    'https://appleid.cdn-apple.com/appleauth/static/jsapi/appleid/1/en_US/appleid.auth.js',
    'appleIdCDN',
    () => {
      // appleID 初始化
      apple.init()
      isLoadappleIdCDN = true
    }
  )
})

// AppleID登录
async function handleAppleLogin() {
  if (!isLoadappleIdCDN) return // 没加载完成无视点击事件
  loginStore.appleLogin()
}

// 谷歌重定向登录
function handleGoogleLogin() {
  loginStore.redirectGoogleLogin()
  // if (isShowProdLogin.value) {
  //   loginStore.redirectGoogleLogin()
  // } else {
  //   showToast('测试环境不支持谷歌登录')
  // }
}
</script>

<style lang="scss">
@import './scss/index.scss';
</style>
